import { useLang } from '@/i18n';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';

export default function ProductJP() {
    const { t } = useLang('dp3.landing.product.product_info');
    const items = [
        { label: t('item1_label'), value: t('item1_value') },
        { label: t('item2_label'), value: t('item2_value') },
        { label: t('item3_label'), value: t('item3_value') },
        { label: t('item4_label'), value: t('item4_value') },
        { label: t('item5_label'), value: t('item5_value') },
        { label: t('item6_label'), value: t('item6_value') },
        { label: t('item7_label'), value: t('item7_value') },
        { label: t('item8_label'), value: t('item8_value') },
        { label: t('item9_label'), value: t('item9_value') },
        { label: t('item10_label'), value: t('item10_value') },
        { label: t('item11_label'), value: t('item11_value') },
        { label: t('item12_label'), value: t('item12_value') },
        { label: t('item13_label'), value: t('item13_value') },
        { label: t('item14_label'), value: t('item14_value') },
    ];

    return (
        <div className={`page-productJP ${styles.ProductJP} GtmModuleData-section`} data-section-id={'dp3-ProductJP'} data-section-title={t('title')}>
            <EcoSectionCommon title={'商品情報'} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.ProductJP}`}>
                <div className="product-info">
                    <div className="product-main">
                        <div className="product-bg">
                            <div className="product-name">{t('title')}</div>
                            <div className="image-row">
                                <div className="image-item">
                                    <img src="https://websiteoss.ecoflow.com/upload/image/1750126378047/img1.png" alt={t('item1')} />
                                    <span>{t('item1')}</span>
                                </div>
                                <div className="image-item">
                                    <img src="https://websiteoss.ecoflow.com/upload/image/1750126378368/img2.png" alt={t('item2')} />
                                    <span>{t('item2')}</span>
                                </div>
                                <div className="image-item">
                                    <img src="https://websiteoss.ecoflow.com/upload/image/1750126377430/img3.png" alt={t('item3')} />
                                    <span>{t('item3')}</span>
                                </div>
                                <div className="image-item">
                                    <img src="https://websiteoss.ecoflow.com/upload/image/1750126377725/img4.png" alt={t('item4')} />
                                    <span>{t('item4')}</span>
                                </div>
                            </div>
                        </div>
                        <div className="accessories">
                            <div className="acc-item">
                                <span>{t('item5')}</span>
                                <img src="https://websiteoss.ecoflow.com/upload/image/1750126378541/img5.png" alt={t('item5')} />
                            </div>
                            <div className="acc-item">
                                <span>{t('item6')}</span>
                                <img src="https://websiteoss.ecoflow.com/upload/image/1750126377036/img6.png" alt={t('item6')} />
                            </div>
                            <div className="acc-item">
                                <span>{t('item7')}</span>
                                <img src="https://websiteoss.ecoflow.com/upload/image/1750127958640/img7.png" alt={t('item7')} />
                            </div>
                            <div className="acc-item">
                                <span>{t('item8')}</span>
                                <img src="https://websiteoss.ecoflow.com/upload/image/1750127958478/img8.png" alt={t('item8')} />
                            </div>
                        </div>

                        <div className="product-specs">
                            {items.map((item, index) => (
                                <div className="spec-item" key={index}>
                                    <span className="label">{item.label} : </span>
                                    <span className="value">{item.value}</span>
                                </div>
                            ))}
                        </div>

                        <div className="product-tip">
                            *
                            X-Boost機能は、定格出力を超える高出力の電化製品を使用可能にするEcoFlowの独自技術です。電圧を下げて定格出力以内に抑えることで動作させるため、電化製品の性能は通常時と比べて低下します。接続機器によっては、使用できない場合もあるためご注意ください。また、ポータブル電源がAC電源で充電されている間（パススルーモード時など）は使用できません。
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
